import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { ReactNode } from "react";
import { CabecalhoCartao, Cartao, EstadoVazio, TituloCartao } from "../../../../core/styles/superficies";

interface SecaoCartaoProps {
    titulo: string;
    /** Ícone da seção. Ganha um losango colorido no cabeçalho e reaparece no estado vazio. */
    icone?: ReactNode;
    /** Cor de realce do ícone — dá a cada seção uma identidade reconhecível de relance. */
    cor?: string;
    /** Botões do canto direito do cabeçalho. */
    acoes?: ReactNode;
    vazio?: boolean;
    mensagemVazia?: string;
    /** Sem padding interno — para conteúdo que já se organiza sozinho, como tabelas. */
    semRecuo?: boolean;
    children?: ReactNode;
}

/**
 * Cartão de seção padrão da tela, sobre as superfícies compartilhadas do sistema.
 *
 * Cada seção tem ícone e cor próprios porque a tela mostra oito blocos de uma vez: só com o
 * título, todos ficam com o mesmo peso e é preciso ler para achar o que se procura.
 */
export const SecaoCartao = ({
    titulo,
    icone,
    cor,
    acoes,
    vazio,
    mensagemVazia,
    semRecuo,
    children,
}: SecaoCartaoProps) => (
    <Cartao sx={{ height: "100%" }}>
        <CabecalhoCartao>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
                {icone && (
                    <Box
                        sx={{
                            width: 28,
                            height: 28,
                            flexShrink: 0,
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: theme => cor ?? theme.palette.primary.main,
                            backgroundColor: theme => alpha(cor ?? theme.palette.primary.main, 0.12),
                            "& svg": { fontSize: 16 },
                        }}
                    >
                        {icone}
                    </Box>
                )}
                <TituloCartao>{titulo}</TituloCartao>
            </Box>
            {acoes && <Box sx={{ display: "flex", gap: 1 }}>{acoes}</Box>}
        </CabecalhoCartao>

        {vazio ? (
            <EstadoVazio>
                {icone}
                <Typography sx={{ fontSize: "0.8125rem" }}>{mensagemVazia}</Typography>
            </EstadoVazio>
        ) : (
            <Box sx={{ padding: semRecuo ? 0 : 2, flex: 1, minWidth: 0 }}>{children}</Box>
        )}
    </Cartao>
);
